import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import DownloadIcon from '@material-ui/icons/CloudDownload'
import { isEmpty } from 'lodash'
import get from 'lodash/get'
import toLower from 'lodash/toLower'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as Model from 'api/model'
import * as PoziUtils from 'api/utils'
import { ConfigLayerCapability } from 'config/catalog/ConfigLayerCapability'
import { ConfigLayerCapabilityWFS } from 'config/catalog/ConfigLayerCapabilityWFS'
import { ICON_COLOR_ENABLED, PANEL_TITLE_DOWNLOAD } from 'drawer/tabs/layers/panels/LayerPanels'
import LayerPanelsExpansion from 'drawer/tabs/layers/panels/LayerPanelsExpansion'
import Loading from 'utils/Loading'

import LayerDownloadPropSelect from './LayerDownloadPropSelect'

const styles = _theme => ({
  root: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 10
  },
  loading: {
    paddingLeft: 10
  }
})

class LayerDownload extends React.Component {
  constructor (props) {
    super(props)
    const { titleid, layerConf, layerType } = this.props
    this.selectValues = []
    this.isVisible = Model.get('config.layout.drawer.tabs.layers.propsDownload.visible', true)

    // Download is only available for GeoJSON layers
    this.isValidLayerType = toLower(layerType) === 'geojson'

    // Attempt to use the outputFormats from the layer config
    const outputFormats = layerConf?.config?.spatial?.outputFormats

    this.state = {
      outputFormats
    }
  }

  componentDidMount () {
    const { panelFeatureTitle } = this.props
    const { outputFormats } = this.state

    // console.debug('LayerDownload - component did mount', outputFormats)

    // If the panel mounted expanded and we don't have any output formats
    // yet, start fetching WFS capabilities
    const panelIsExpanded = panelFeatureTitle === PANEL_TITLE_DOWNLOAD
    if (panelIsExpanded && !outputFormats) {
      this.fetchWfsCapabilities()
    }
  }

  fetchWfsCapabilities = async () => {
    const { layerConf } = this.props

    let outputFormats = {}

    try {
      // Create a WFS GetCapabilities request from the current layer configuration
      // and extract the output formats from the result.

      const catalogueUrl = PoziUtils.getLayerUrl(layerConf, {
        REQUEST: 'GetCapabilities',
        SERVICE: 'WFS',
        VERSION: '2.0.0'
      })

      const catalogueResponse = await ConfigLayerCapability.fetchUrl(catalogueUrl)
      const wfsCapabilities = ConfigLayerCapabilityWFS.getCapabilities(catalogueResponse)

      // console.debug('LayerDownload - WFS Capabilities', wfsCapabilities)

      // Always return an object, even if it's empty. This way we know we've tried to get
      // the data and we won't keep fetching the WFS catalogue
      outputFormats = ConfigLayerCapabilityWFS.getOutputFormats(wfsCapabilities) || {}

      // console.debug('LayerDownload - WFS Catalogue', catalogue)
    } catch (error) {
      console.log('LayerDownload - WFS Catalogue fetch error', error)
    } finally {
      this.setState({
        outputFormats
      })
    }
  }

  getSelectValues () {
    const { outputFormats } = this.state

    if (!outputFormats || isEmpty(outputFormats)) {
      return []
    }

    const selectValues = Object.keys(outputFormats).sort()
    return selectValues
  }

  handleExpansionPanel = () => {
    console.log('handleExpansionPanel')
    const { outputFormats } = this.state

    // Fetch when expansion panel has been clicked
    if (!outputFormats) {
      this.fetchWfsCapabilities()
    }
  }

  render () {
    const { classes, layerConf, titleid } = this.props
    const { outputFormats } = this.state

    if (!this.isVisible || !this.isValidLayerType) {
      console.log('LayerDownload - render - layer not visible or layer type is not valid', titleid, this.isVisible, this.isValidLayerType)

      return null
    }

    let markup = ''

    const layerIsDownloadable = layerConf?.downloadable ?? true
    if (!layerIsDownloadable) {
      console.debug('LayerDownload - render - layer marked as not downloadble.', titleid)
      markup = (
        <div className={classes.root}>
          This layer has not been enabled for download.
        </div>
      )
    } else if (!outputFormats) {
      // console.debug('LayerDownload - render - outputFormats does not exist (yet).', titleid)

      markup = (
        <div className={classes.loading}>
          <Loading text="" />
        </div>
      )
    } else {
      this.selectValues = this.getSelectValues()

      markup = (
        <div className={classes.root}>
          <LayerDownloadPropSelect titleid={titleid} selectValues={this.selectValues} outputFormats={outputFormats} />
        </div>
      )
    }

    const headerIcon = <DownloadIcon htmlColor={ICON_COLOR_ENABLED} />

    return <LayerPanelsExpansion titleid={titleid} panelTitle={PANEL_TITLE_DOWNLOAD} headerIcon={headerIcon} markup={markup} cb={this.handleExpansionPanel} />
  }
}

LayerDownload.propTypes = {
  classes: PropTypes.object.isRequired,
  layerConf: PropTypes.object.isRequired,
  layerType: PropTypes.string.isRequired,
  titleid: PropTypes.string.isRequired,
  panelFeatureTitle: PropTypes.string.isRequired
}

function mapStateToProps (state, ownProps) {
  const layerConf = state.layers?.[ownProps.titleid]
  const panelFeatureTitle = layerConf?.panelFeatureTitle ?? ''
  const layerType = layerConf?.type ?? null

  return {
    layerConf,
    layerType,
    panelFeatureTitle
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(LayerDownload)
  )
)
